export default __webpack_public_path__ + "static/media/cry.f7c602c9.gif";